export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 260;
export const SIDE_NAV_COLLAPSED_WIDTH = 108;
export const SIDE_NAV_COLLAPSED_WIDTH_MOBILE = 85;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 60;
export const TOP_NAV_HEIGHT = 55;
export const SIDE_NAV_LIGHT = "SIDE_NAV_LIGHT";
export const SIDE_NAV_DARK = "SIDE_NAV_DARK";
export const NAV_TYPE_SIDE = "SIDE";
export const NAV_TYPE_TOP = "TOP";
export const DIR_LTR = "ltr";
export const DIR_RTL = "rtl";
export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
export const HEADER_BG_DEFAULT_COLOR_LIGHT = "#ffffff";
export const HEADER_BG_DEFAULT_COLOR_DARK = "#283142";
export const LAYOUT_CONTENT_GUTTER = 25;
export const LAYOUT_CONTENT_GUTTER_SM = 15;
export const SIDE_NAV_DARK_BG_COLOR = "#001529";

export const BLUE_BASE = "#3e79f7";
export const PURPLE_BASE = "#7C35FF"; // New design colors
export const PURPLE_LIGHT = "#B4A5EB"; // Active filter border color
export const PURPLE_LIGHTER = "#C6BBF1"; // Inactive filter border color
export const CYAN_BASE = "#2EE6A9";
export const GREEN_BASE = "#21B573";
export const MAGENTA_BASE = "#eb2f96";
export const PINK_BASE = "#eb2f96";
export const RED_BASE = "#de4436";
export const RED_ERROR = "#FD241E"; // Error/validation red
export const ORANGE_BASE = "#fa8c16";
export const YELLOW_BASE = "#fadb14";
export const VOLCANO_BASE = "#ff6b72";
export const GEEK_BLUE_BASE = "#17bcff";
export const LIME_BASE = "#a0d911";
export const GOLD_BASE = "#ffc542";

// Password strength colors
export const PASSWORD_WEAK = "#FF4C61";
export const PASSWORD_FAIR = "#FF974D";
export const PASSWORD_GOOD = "#FFD84D";
export const PASSWORD_STRONG = "#2EE6A9";

export const WHITE = "#ffffff";
export const PAPER_WHITE = "#F8F8FC"; // New design colors
export const DARK = "#0E0E10"; // New design colors
export const GRAY_DARK = "#1a3353";
export const GRAY = "#414344";// New design colors
export const GRAY_LIGHT = "#686C6F";// New design colors
export const GRAY_LIGHTER = "#999999";// New design colors
export const GRAY_LIGHTEST = "#D9D9D9";// New design colors
export const BORDER_LIGHT = "#E8E2FF";// New design colors
export const BODY_BACKGROUND = "#F8F7FC"; // New design colors

export const FONT_SIZE_BASE = 14;

export const TEMPLATE = {
  HEADER_HEIGHT,
  FOOTER_HEIGHT,
  TOP_NAV_HEIGHT,
  CONTENT_HEIGHT_OFFSET,
  SIDE_NAV_WIDTH,
  SIDE_NAV_COLLAPSED_WIDTH,
  SIDE_NAV_DARK_BG_COLOR,
  CONTENT_MAX_WIDTH,
  HEADER_BG_DEFAULT_COLOR_LIGHT,
  HEADER_BG_DEFAULT_COLOR_DARK,
  LAYOUT_CONTENT_GUTTER,
  LAYOUT_CONTENT_GUTTER_SM,
  NAV_TYPE_SIDE,
  NAV_TYPE_TOP,
  SIDE_NAV_LIGHT,
  SIDE_NAV_DARK,
  DIR_LTR,
  DIR_RTL,
};

export const THEME_COLOR = {
  BLUE: BLUE_BASE,
  PURPLE: PURPLE_BASE,
  PURPLE_LIGHT: PURPLE_LIGHT,
  PURPLE_LIGHTER: PURPLE_LIGHTER,
  CYAN: CYAN_BASE,
  GREEN: GREEN_BASE,
  MAGENTA: MAGENTA_BASE,
  PINK: PINK_BASE,
  RED: RED_BASE,
  RED_ERROR: RED_ERROR,
  ORANGE: ORANGE_BASE,
  YELLOW: YELLOW_BASE,
  VOLCANO: VOLCANO_BASE,
  GEEK_BLUE: GEEK_BLUE_BASE,
  LIME: LIME_BASE,
  GOLD: GOLD_BASE,
  PASSWORD_WEAK: PASSWORD_WEAK,
  PASSWORD_FAIR: PASSWORD_FAIR,
  PASSWORD_GOOD: PASSWORD_GOOD,
  PASSWORD_STRONG: PASSWORD_STRONG,
};

export const FONT_WEIGHT = {
  LIGHTER: "lighter",
  LIGHT: 300,
  NORMAL: 400,
  SEMIBOLD: 500,
  SEMIBOLD_PLUS: 600,
  BOLD: 700,
  BASE: 400,
  BOLDER: "bolder",
};

export const FONT_SIZES = {
  BASE: FONT_SIZE_BASE,
  SM: 12,
  LG: FONT_SIZE_BASE + 2,
  XL: 18,
  XXL: 24,
  XXXL: 32,
  BUTTON: 16,
  HERO: 48,
};

export const SPACER = {
  0: "0",
  1: "0.25rem",
  2: "0.5rem",
  3: "1rem",
  4: "1.5rem",
  5: "3rem",
};

const BREAKPOINT = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1400px",
  xxl: "1600px",
};

export const MEDIA_QUERIES = {
  DESKTOP: `(min-width: ${BREAKPOINT.xl})`,
  LAPTOP: `(max-width: ${BREAKPOINT.xxl})`,
  LAPTOP_ABOVE: `(min-width: ${BREAKPOINT.xxl})`,
  TABLET: `(max-width: ${BREAKPOINT.lg})`,
  MOBILE: `(max-width: ${BREAKPOINT.md})`,
  MIN_MOBILE: `(min-width: ${BREAKPOINT.md})`,
};

export const BORDER = {
  BASE_COLOR: "#e6ebf1",
};

export const BORDER_RADIUS = {
  SM: 4,
  MD: 8,
  BASE: 10,
  PILL: 50,
};

export const GRAY_SCALE = {
  DARK,
  WHITE,
  GRAY_DARK,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTER,
  GRAY_LIGHTEST,
};

export const DARK_MODE = {
  TEXT_COLOR: "#b4bed2",
  HEADING_COLOR: "#d6d7dc",
  BG_COLOR: "#283142",
  BORDER_BASE_COLOR: "#4d5b75",
  HOVER_BG_COLOR: "#364663",
  ACTIVE_BG_COLOR: "#293956",
  DROP_DOWN_SHADOW:
    "0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 58%), 0 9px 28px 8px rgb(0 0 0 / 15%)",
};

export const CONTENT_WRAPPER_SHADOW = "-563px 123px 161px 0 rgba(209, 184, 255, 0.00), -360px 79px 148px 0 rgba(209, 184, 255, 0.01), -203px 44px 124px 0 rgba(209, 184, 255, 0.04), -90px 20px 92px 0 rgba(209, 184, 255, 0.07), -23px 5px 51px 0 rgba(209, 184, 255, 0.08)";
